import { Component, OnInit, Inject } from '@angular/core';
import { MdInputModule, MdCheckboxModule, MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Utility } from '../../../common/utility';

import { DialogService } from '../../../shared/services/dialog.service';
import { BaseService } from '../../../shared/services/base.service';
import { AppMessages } from '../../../shared/constants/messages';

import { DialogComponent } from '../../../components/dialog/dialog.component';
import { FormGroup, FormBuilder, Validators, FormControl, PatternValidator } from '@angular/forms';

import { NoteInvoiceModel } from '../../../models/consultation/cash-sale.model';
import { CashSaleService } from './cash-sale.service';

@Component({
  selector: 'note-invoice-popup',
  templateUrl: 'note-invoice.popup.component.html',
  providers: [CashSaleService]

})
export class NoteInvoicePopupComponent implements OnInit {
  addNoteForm: FormGroup;
  constructor(
    public utility: Utility,
    public baseService: BaseService,
    public dialogService: DialogService,
    private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<NoteInvoicePopupComponent>,
    private cashSaleService: CashSaleService,
    @Inject(MD_DIALOG_DATA) public data: { invoiceId: string, consultationId: string, note: string }
  ) {
    this.createForm();
    if (this.data) {
      if (this.data.invoiceId) {
        this.getNoteInvoice();
      } else {
        this.addNoteForm.controls.note.setValue(this.data.note || '');
      }
    }
  }

  ngOnInit() {

  }

  createForm() {
    this.addNoteForm = this.formBuilder.group({
      note: ['', [Validators.required]],
    });

  }

  onSubmit() {
    if (this.addNoteForm.dirty && this.addNoteForm.valid) {
      const item = {
        FormName: 'Add Note',
        Note: this.addNoteForm.value.note
      };
      if (this.data.invoiceId) {
        this.cashSaleService.addNoteToInvoice(
          this.data.invoiceId, this.addNoteForm.controls.note.value
        ).subscribe(result => {
          if (result) {
            this.onCloseDialog(item);
          }
        });
      } else {
        this.onCloseDialog(item);
      }
    }
  }

  onCloseDialog(item = null) {
    this.dialogRef.close(item);
  }

  getNoteInvoice() {
    this.cashSaleService.getInvoice(this.data.invoiceId).subscribe(
      (result) => {
        if (result) {
          const res = result.json();
          this.addNoteForm.controls.note.setValue(res.note);
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/cash-sale/note-invoice.popup.component.ts